import { httpsCallable } from 'firebase/functions';
import type {
  IssueSsoTokenRequest,
  IssueSsoTokenResponse,
} from '@kawai/shared';
import { functions } from '../firebase.js';

const issueSsoTokenCallable = httpsCallable<
  IssueSsoTokenRequest,
  IssueSsoTokenResponse
>(functions, 'authIssueSsoToken');

/**
 * A-37: 管理アプリ間のヘッダーリンク遷移時に、actor 自身の uid + 既存 claims で
 * Custom Token を発行する Callable（T-08 と同じ authIssueSsoToken）の薄いラッパ。
 *
 * 別オリジン（サブドメイン）への遷移では Firebase Auth セッションが共有されないため、
 * 発行した Custom Token を遷移先 URL の fragment で受け渡して signInWithCustomToken させる。
 * 失敗時は呼出側（makeSsoAppNavigation）が素のリンク遷移に fall-through する。
 */
export async function callIssueSsoToken(
  input: IssueSsoTokenRequest,
): Promise<IssueSsoTokenResponse> {
  const res = await issueSsoTokenCallable(input);
  return res.data;
}
